export const TableSessionType = {
    DINE_IN  : 1,
    PICKUP   : 2,
    DELIVERY : 3,
    LANDING  : 4,
    DINE_IN_WITH_PAYMENT: 5,
}

export const tableSessionTypes = [
    {
        key: TableSessionType.DINE_IN,
        label: lang.dine_in,
    },
    {
        key: TableSessionType.PICKUP,
        label: lang.pickup,
    },
    {
        key: TableSessionType.DELIVERY,
        label: lang.delivery,
    },
    {
        key: TableSessionType.LANDING,
        label: lang.landing,
    },
    {
        key: TableSessionType.DINE_IN_WITH_PAYMENT,
        label: `${lang.dine_in} (${lang.online_payment})`,
    },
]